import React from 'react';
import { I } from './Icons';

type IconName = keyof typeof I;
type Color = 'indigo' | 'teal' | 'amber' | 'rose' | 'green' | 'blue';

interface KPIProps {
  label:     string;
  value:     React.ReactNode;
  trend?:    string;
  trendDir?: 'up' | 'down' | 'neutral';
  icon?:     IconName;
  color?:    Color;
}

const COLORS: Record<Color, { bg: string; fg: string }> = {
  indigo: { bg: 'var(--primary-100)', fg: 'var(--primary-700)' },
  teal:   { bg: 'var(--accent-100)',  fg: 'var(--accent-700)'  },
  amber:  { bg: '#fef3c7',            fg: '#92400e' },
  rose:   { bg: '#fee2e2',            fg: '#991b1b' },
  green:  { bg: '#dcfce7',            fg: '#166534' },
  blue:   { bg: '#dbeafe',            fg: '#1e40af' },
};

export const KPI: React.FC<KPIProps> = ({ label, value, trend, trendDir = 'up', icon, color = 'indigo' }) => {
  const c = COLORS[color];
  const IconC = icon ? I[icon] : null;
  return (
    <div className="kpi">
      {IconC && (
        <div className="kpi-icon" style={{ background: c.bg, color: c.fg }}>
          <IconC />
        </div>
      )}
      <div className="kpi-label">{label}</div>
      <div className="kpi-value">{value}</div>
      {trend && (
        <div className={`kpi-trend ${trendDir}`}>
          {trendDir === 'up'   && <I.TrendingUp size={12} />}
          {trendDir === 'down' && <I.TrendingDown size={12} />}
          {trend}
        </div>
      )}
    </div>
  );
};
